import React, { useState } from "react";
import { Route, Switch, Link } from "react-router-dom";
import Amplify, { Auth } from "aws-amplify";
import NavDrawer from "storybookComponents/NavDrawer";
import MaterialLink from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core";
import * as path from "constants/path";
import { NAVBAR_WIDTH } from "constants/index";
import Loader from "storybookComponents/Loader";
import UserContext from "context/UserContext";
import {
  getPropertyId,
  setProperty,
  getUserEmail,
  setPropertyIdLocalStorage,
  premiumApps,
  globalTohyMail,
} from "common";
import environment from "environments/environment";
import { useCustomEventListener } from "react-custom-events";
import { EVENT_CODES } from "constants/index";
import UnAuthorizedUserPage from "./public-routes/unauthorized";
import { getDefaultOrg, getSuborgDetails } from "relay/common";
import Content from "./appContent";
import EnrollPage from "public-routes/enroll";
import ReferPage from "public-routes/refer";
import ResidentialPortalPage from "public-routes/residential-portal";
import ResidentialBannerPage from "public-routes/residential-banner";
import { getMenuForNavDrawer } from "./navDrawerMenu";
import Storage from "common/localStorage";
import CacheBuster from "./CacheBuster";
import "bootstrap/dist/css/bootstrap.min.css";
import "./icons/style.css";
import { _getApps } from "components/AppSwitcher/apis";
import _ from "lodash";
import { compare } from "content/utils/commonParsing";

var navDrawerToggle;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    height: "100vh",
  },
  contentWrapperShift: {
    marginLeft: NAVBAR_WIDTH,
    width: `calc(100% - ${NAVBAR_WIDTH}px)`,
    height: "100%",
    flex: 1,
    display: "flex",
    flexGrow: 1,
    flexFlow: "column",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  contentWrapperNoShift: {
    width: "100%",
    height: "100%",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    paddingLeft: "20px",
  },
  appBarShift: {
    marginLeft: NAVBAR_WIDTH,
    width: `calc(100% - ${NAVBAR_WIDTH}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    paddingLeft: "20px",
  },
  appConatiner: {
    margin: -16,
  },
}));

const authConfig = {
  Auth: {
    userPoolId: process.env.REACT_APP_UserPool,
    userPoolWebClientId: process.env.REACT_APP_ClientId,
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL,
    authenticationFlowType: "USER_PASSWORD_AUTH",
    cookieStorage: {
      domain: process.env.REACT_APP_domain,
      path: "/",
      expires: 7,
      secure: process.env.NODE_ENV === "production",
    },
  },
};

Amplify.configure(authConfig);

const getAuthState = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user;
  } catch (err) {
    console.warn("getAuthState error: ", err.message || err);
    return undefined;
  }
};

const accountsLink = process.env.REACT_APP_ACCOUNTS_LINK;

function Application({ appSwitcher, user, userName, userEmail, ...rest }) {
  const classes = useStyles();
  const { subOrgDetails, setSuborgDetails } = React.useContext(UserContext);
  const [propertyId, setPropertyId] = React.useState(subOrgDetails.id);
  const [menuType, setMenuType] = React.useState("hyRaf");
  const [auth, setAuth] = React.useState(true);
  const [userDetails, setUser] = React.useState({
    name: userName || userEmail,
    ...user,
  });
  const [expiredAt, setExpiredAt] = React.useState(null);
  const [apps, setApps] = React.useState([]);
  const handleUserName = (name) => {
    setUser({
      name: name,
      ...user,
    });
  };

  console.log("subOrgDetails", subOrgDetails);
  // Change Navdrawer content
  const setOriginNavItems = (type) => {
    setMenuType(type);
  };

  const secondaryMenu = [
    {
      link_component: MaterialLink,
      path: "/",
      name: "My Account",
      href: `${process.env.REACT_APP_ACCOUNTS_LINK}`,
      target: "_blank",
      rel: "noreferrer",
    },
  ];

  const handleSignOut = async () => {
    try {
      await window.localStorage.clear();
      window.location.assign(`${accountsLink}/logout?goto=hyRaf`);
    } catch (err) {
      console.error("logout error: ", err);
    }
  };

  useCustomEventListener("UpdateUserName", handleUserName);
  useCustomEventListener("UserSignOut", handleSignOut);

  const parsePath = (p) => {
    if (p.includes("campaignsReports")) {
      return p;
    }
    if (p.startsWith(path.getAppPath() + "/by-campaign")) {
      return path.getAppPath() + "/by-campaigns";
    }
    if (p.startsWith(path.getAppPath() + "/by-contact")) {
      return path.getAppPath() + "/by-contact";
    }
    if (p.startsWith(path.getAppPath() + "/by-property")) {
      return path.getAppPath() + "/by-property";
    }
    if (p.startsWith(path.getAppPath() + "/campaign")) {
      return path.getAppPath();
    }
    return p;
  };
  const setData = (property) => {
    let urlKeys = window.location.pathname.split("/");
    let drawerValue = "";
    if (urlKeys.length == 3) {
      if (urlKeys[2] !== "/") {
        drawerValue = "/" + urlKeys[2];
      }
    }
    setPropertyIdLocalStorage(property.id);
    setSuborgDetails(property);
    window.localStorage.setItem("userEmail", property.userEmail);
    rest.history.push(path.getAppPath(property.id) + drawerValue);
    getApps(property.org.id, property.id, property.orgLevel);
  };
  const getModulesDetailsForAuthorization = (apps, suborgId, orgLevel) => {
    let journeyAIModules = [];
    for (let i = 0; i < apps.length; i++) {
      if (premiumApps.includes(apps[i].name)) {
        const { name, url, orgLevelUrl } = globalTohyMail[apps[i].name];
        journeyAIModules.push({
          id: `journeyAIModules_${name}`,
          name: name === "Raf" ? "Refer-a-Friend" : name,
          title: name,
          unauthUser: apps[i].access === "none" && apps[i].authorized,
          premium: !apps[i].authorized,
          journeyAIModules: true,
          url: `${process.env.REACT_APP_JAI_hostName}/${suborgId}/${url}`,
        });

        //If an org/suborg is using hyBlast then they are eligible to use Success center Blast automatically
        //It may change later when we will add success center drips
        if (name === "Blasts") {
          journeyAIModules.push({
            id: `journeyAIModules_Success Center`,
            name: "Success Center",
            title: "Success Center",
            unauthUser: apps[i].access === "none" && apps[i].authorized,
            premium: !apps[i].authorized,
            journeyAIModules: true,
            url:
              process.env.REACT_APP_JAI_hostName +
              "/" +
              suborgId +
              "/hyblast/analysis",
          });
        }
      }
    }

    return journeyAIModules
      .slice()
      .sort((a, b) => compare(a.name, b.name, false));
  };

  const getApps = async (orgId, suborgId, orgLevel) => {
    try {
      let response = await _getApps(orgId, orgLevel ? null : suborgId);
      if (response.length > 1) {
        let authorizedDetails = getModulesDetailsForAuthorization(
          response,
          suborgId,
          orgLevel
        );
        setApps([...response, ...authorizedDetails]);
        let hyRaf = response.find((app) => app.name == "Refer-a-Friend");
        if (hyRaf) {
          setAuth(hyRaf.authorized);
          setExpiredAt(hyRaf.expiredAt);
          if (hyRaf.expiredAt) {
            if (!hyRaf.authorized) {
              rest.history.push(`/${suborgId}/unauthorized`);
            } else if (new Date() > new Date(hyRaf.expiredAt)) {
              rest.history.push(`/${suborgId}/expired`);
            }
          }
        }
      } else {
        setApps([]);
      }
    } catch (err) {
      console.log("Err", err);
    }
  };

  React.useEffect(() => {
    getApps(subOrgDetails.org.id, subOrgDetails.id, false);
  }, [1]);

  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <NavDrawer
            environment={environment}
            user={{
              name: userName || userEmail,
              ...user
            }}
            // path={window.location.pathname}
            user_name={user && user.attributes && user.attributes.name}
            user_email={user && user.attributes && user.attributes.email}
            access={true}
            org={{
              id: subOrgDetails.org.id,
            }}
            property={{
              id: subOrgDetails.id,
              propertyLogoUrl: subOrgDetails.propertyLogoUrl,
              propertyManagerLogoUrl: subOrgDetails.propertyManagerLogoUrl,
            }}
            propertyId={subOrgDetails.id}
            initialIDValue={propertyId}
            authorized={true}
            orgLevel={false}
            menu={getMenuForNavDrawer(menuType, path.getAppPath())}
            handleNotification={() => {}}
            link_component={Link}
            header_props={secondaryMenu}
            suborg_change_available={true}
            onSelectOrg={(org) => {
              if (org.suborgs) {
                let data = {
                  ...org.suborgs[0],
                  org: {
                    id: org.id,
                    name: org.name,
                  },
                  orgLevel: true,
                  userEmail: userEmail,
                };
                setData(data);
              } else {
                setSuborgDetails({
                  ...subOrgDetails,
                  orgLevel: true,
                });
                getApps(subOrgDetails.org.id, subOrgDetails.id, true);
              }
            }}
            onSelectProperty={(row) => {
              let data = {
                ...row[1],
                org: {
                  id: row[0].id,
                  name: row[0].name,
                },
                orgLevel: false,
                userEmail: userEmail,
              };
              setData(data);
            }}
            is_online={true}
            logout_function={handleSignOut}
            updateDimensions={() => {}}
            handleNavDrawer={(data) => {
              console.log("handleNavDrawer : ", data);
            }}
            pathname={parsePath(rest.location.pathname)}
            appName="hyRaf"
          >
            <Content
              classes={classes}
              user={{
                ...user,
                username: userEmail,
              }}
              orgLevel={subOrgDetails.orgLevel}
              propertyId={subOrgDetails.id}
              org={{ id: subOrgDetails.org.id }}
              setOriginNavItems={setOriginNavItems}
              apps={apps}
              expiredAt={expiredAt}
              unauth={!auth}
              isExpired={expiredAt && new Date() > new Date(expiredAt)}
              {...rest}
            />
          </NavDrawer>
        );
      }}
    </CacheBuster>
  );
}

const App = (props) => {
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [userName, setUserName] = React.useState();
  const [userEmail, setUserEmail] = React.useState();
  const { setSuborgDetails } = React.useContext(UserContext);

  const getNameEmail = (user) => {
    if (user && user.attributes) {
      if (user.attributes.email || user.attributes.name) {
        return {
          email: user.attributes.email,
          name: user.attributes.name,
        };
      } else if (user.attributes.identities) {
        let identities = JSON.parse(user.attributes.identities);
        return {
          email: identities[0].userId,
          name: identities[0].userId,
        };
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const handleSignin = () => {
    window.location.href = `${accountsLink}?goto=hyRaf`;
  };

  React.useEffect(() => {
    if (window.location.hostname === "localhost") {
      loadProperty("iq+admin@hy.ly");
      return;
    }
    loadUser();
  }, [1]);

  const loadUser = async () => {
    try {
      const user = await getAuthState();
      let userDetails = getNameEmail(user);
      if (userDetails) {
        setUserEmail(userDetails.email);
        setUserName(userDetails.name);
      }
      setUserData(user);
      if (user && userDetails && userDetails.email) {
        loadProperty(userDetails.email);
      }
      // if (window.location.href.includes('from=myhyly')) {
      else window.location.href = `${accountsLink}?goto=hyRaf`;
      // } else {
      //   setLoading(false);
      // }
    } catch (err) {
      setLoading(false);
    }
  };

  const getOrgData = async (userEmail, userName) => {
    window.localStorage.clear();
    let defaultOrg = await getDefaultOrg("Refer-a-Friend");
    if (defaultOrg.authorizedOrgs && defaultOrg.authorizedOrgs.length) {
      let org = defaultOrg.authorizedOrgs[0];
      let property = org.suborgs[0];
      setProperty({
        ...property,
        orgid: org.id,
        userEmail: userEmail,
        userName: userName,
      });
    } else {
      Storage.setItem("emptyAuth", true);
      handleUnAuth();
    }
  };

  const loadProperty = async (userEmail, userName) => {
    setLoading(true);
    let propertyId = getPropertyId(true);
    let _userEmail = getUserEmail();
    if ((!propertyId && propertyId.length !== 36) || userEmail !== _userEmail) {
      await getOrgData(userEmail, userName);
    } else {
      try {
        let subOrgDetails = await getSuborgDetails(propertyId);
        if (
          subOrgDetails &&
          subOrgDetails.authorizedSuborgs &&
          subOrgDetails.authorizedSuborgs[0]
        ) {
          setSuborgDetails({
            ...subOrgDetails.authorizedSuborgs[0],
            orgLevel: false,
          });
        } else {
          await getOrgData(userEmail, userName);
        }
      } catch (err) {
        console.log("Err", err);
      }
    }
    setLoading(false);
  };

  const handleUnAuth = () => {
    window.location.href = "/unauthorized";
  };

  useCustomEventListener(EVENT_CODES.UNAUTH_USER, handleUnAuth);

  if (window.location.hostname === "localhost") {
    return loading ? (
      <Loader />
    ) : (
      <Application
        userName="IQ Admin"
        userEmail="iq+admin@hy.ly"
        user={{
          attributes: {
            email: "iq+admin@hy.ly",
            email_verified: true,
            name: "IQ Admin",
            sub: "14d603dd-5bc8-4eee-beed-14bd827b6578",
          },
          username: "iq+admin@hy.ly",
        }}
        {...props}
      />
    );
  }

  React.useEffect(() => {
    if (!userData) handleSignin();
  }, [userData]);

  return loading ? (
    <Loader />
  ) : (
    <>
      {/* {
          !userData ?
            <HomePage
              handleSignin={handleSignin}
            />
            : */}
      <Application
        userName={userName}
        userEmail={userEmail}
        user={userData}
        {...props}
      />
      {/* } */}
    </>
  );
};

export default () => {
  return (
    <Switch>
      <Route
        path="/residential-portal/:campaignId"
        component={ResidentialPortalPage}
      />
      <Route
        path="/residential-banner/:campaignId"
        component={ResidentialBannerPage}
      />
      <Route path="/enroll/:campaignId" component={EnrollPage} />
      <Route path="/refer/:campaignId/:enrollId" component={ReferPage} />
      <Route path="/unauthorized" component={UnAuthorizedUserPage} />
      <Route path="/" component={App} />
    </Switch>
  );
};
